import { successToast, errorToast } from './toast';

export default text => {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand('copy');
    successToast('Copied to clipboard');
  } catch (err) {
    errorToast('Error copying to clipboard');
  }
  document.body.removeChild(textArea);
};
